
define('text!templates/pages/account-main/file.ejs',[],function () { return '<td class="file-name">\n    <a href="<%= apiUrl(url, {}) %>" target="_blank"><%= name %></a>\n</td>\n\n<td class="file-size">\n    <%= fileSize(size) %>\n</td>';});

